import { BaseModel } from "./base.model";
import { CustomerModel } from "./customer-model";

export class CasinoGameModel extends BaseModel {

  private customer;
  private config;
  private userSessionService;
  public window: any;
  public id: number;
  public game_name: string;
  public url: any;
  public is_demo: boolean;
  public instanceViewLocation: string;
  public isMobileApp: boolean;
  public betIndex: string;
  public ctx:string

  constructor(
    data,
    config,
    customer: CustomerModel,
    userSessionService,
    isMobileApp: boolean,
    betIndex: string = null,
    ctx:string
  ) {
    super();

    this.config = config;
    this.customer = customer;
    this.isMobileApp = isMobileApp;
    this.userSessionService = userSessionService;
    this.betIndex = betIndex;
    this.ctx = ctx;
    Object.assign(this, data);
    this.url = this.generateBrowseWindowUrl();
    this.setIdentifier(this.id);
    this.setLabel(this.game_name);
    this.setInstanceCategoryType('casino-game');
  }

  public generateBrowseWindowUrl() {
    const appUrl = this.config.getEnv().webservices_url;

    const params = new URLSearchParams();
    if (this.customer) {
      this.is_demo = false;
      params.set('noredirect', 'true');
      params.set('customer_id', this.customer.customerId.toString());
      if (this.isMobileApp) {
        params.set('session_token', this.userSessionService.sessionToken);
      }
    } else {
      this.is_demo = true;
      params.set('customer_id', '');
      params.set('session_token', '');
    }

    params.set('game_launcher_id', this.id.toString());
    params.set('gameName', this.game_name);
    const clientApp = this.config.getClientApp();
    params.set('clientapp', clientApp);

    if (this.betIndex != null)
      params.set('startBetIndex', this.betIndex);
    

    if(this.ctx){
      params.set('ctx',this.ctx)
    }
    const url = `${appUrl}/games/launch-casino?${params.toString()}`;
    return url;
  }
}
